import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface RunAgentTestData {
  testInput: string;
  testOutput: string;
}

interface RunAgentTestResponse {
  data: any;
}

export function useRunAgentTest() {
  const { keycloak } = useKeycloak();

  return useMutation({
    mutationFn: async ({
      testInput,
      testOutput,
    }: RunAgentTestData): Promise<RunAgentTestResponse> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/generate_bundle/functions/run_agent_test`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify({
            testInput,
            testOutput,
          }),
        }
      );

      const data = await response.json();

      return {
        data: data?.data,
      };
    },
  });
}
